"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/Tabs.scss");
require("./modules/tabs");
